import type { PlanUsageDetail } from "@/hooks/usePlanUsageDetails";

/** "Integral · 07h – 18h" no design; aqui, o que a reserva realmente registrou. */
export function buildUsageHeadline(
  detail: PlanUsageDetail | undefined,
  labels: { period: (key: string) => string; overnight: string; day: string },
): string {
  if (!detail) return labels.day;
  const parts: string[] = [];
  if (detail.period) parts.push(labels.period(detail.period));
  else if (detail.isOvernight) parts.push(labels.overnight);
  if (detail.checkInTime && detail.checkOutTime) parts.push(`${detail.checkInTime} – ${detail.checkOutTime}`);
  else if (detail.checkInTime) parts.push(detail.checkInTime);
  return parts.length ? parts.join(" · ") : labels.day;
}

/** "Check-in 07:38 · check-out 17:20 · matilha M". */
export function buildUsageDetail(
  detail: PlanUsageDetail | undefined,
  labels: { checkIn: (time: string) => string; checkOut: (time: string) => string; pack: (name: string) => string },
): string {
  if (!detail) return "";
  const parts: string[] = [];
  if (detail.checkInTime) parts.push(labels.checkIn(detail.checkInTime));
  if (detail.checkOutTime) parts.push(labels.checkOut(detail.checkOutTime));
  if (detail.packName) parts.push(labels.pack(detail.packName));
  return parts.join(" · ");
}
